import './NotificationUtils.css';

export const showNotification = (message: string): void => {
    // Create notification element
    const notification = document.createElement('div');
    notification.className = 'address-copy-notification';
    notification.textContent = message;
    
    // Add to body
    document.body.appendChild(notification);
    
    // Remove after animation
    setTimeout(() => {
        notification.classList.add('fade-out');
        setTimeout(() => {
            if (document.body.contains(notification)) {
                document.body.removeChild(notification);
            }
        }, 300);
    }, 2000);
}; 